<template>
  <svg
    viewBox="25 25 50 50"
    class="icon-loading"
    :class="theme"
  >
    <circle
      cx="50"
      cy="50"
      r="20"
      fill="none"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconLoading',
  props: {
    theme: {
      type: String,
      default: 'light',
      validator: (theme) => ['light', 'dark'].includes(theme)
    }
  }
}
</script>

<style lang="scss">
.icon-loading {
  display: inline-block;
  width: 24px;
  height: 24px;
  animation: revolution 2s linear infinite;
  color: #999;
  stroke: currentcolor;
  stroke-linecap: round;
  stroke-width: 2;

  &.dark {
    color: #000;
  }

  > circle {
    animation: loading-dash 1.5s ease-in-out infinite;
  }
}

@keyframes revolution {
  to {
    transform: rotate(1turn);
  }
}

@keyframes loading-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -40px;
  }

  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -120px;
  }
}
</style>
